import { render, staticRenderFns } from "./AboutSectionCelular.vue?vue&type=template&id=6d5fe2ca&scoped=true&"
import script from "./AboutSectionCelular.vue?vue&type=script&lang=js&"
export * from "./AboutSectionCelular.vue?vue&type=script&lang=js&"
import style0 from "./AboutSectionCelular.vue?vue&type=style&index=0&id=6d5fe2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fe2ca",
  null
  
)

export default component.exports